/**
 * given `json` data object, returns FormData object with data provided
 * to be used with `application/x-www-form-urlencoded` xhr requests
 */
export const toFormData = (json) =>
  Object.keys(json).reduce((formData, field) => {
    formData.set(field, json[field]);
    return formData;
  }, new FormData());

/**
 * given `json` data object, returns a string params in form of `key=value`, concatenated by &
 */
export const toUrlEncodedString = (json) =>
  Object.keys(json)
    .map((field) => (json[field] ? `${field}=${encodeURIComponent(json[field])}` : null))
    .join('&');
